<template>
	<div
		class="container__switcher"
		data-testid="switcher-component"
	>
		<label
			v-if="leftLabel"
			style="margin-right: 0.5rem"
			:class="{ active: !value }"
			:for="uniqueID"
			>{{ leftLabel }}</label
		>
		<div class="container__swicher__checkbox">
			<input
				:id="uniqueID"
				:class="{ dual__option: leftLabel && label }"
				type="checkbox"
				:checked="value"
				:disabled="disabled"
				@input="change($event)"
			/>
		</div>
		<label
			:class="{ active: value }"
			:for="uniqueID"
			>{{ label }}</label
		>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
	props: {
		/**
		 * Label que sera mostrado ao lado do switcher
		 */
		label: String,
		/**
		 * Label que sera mostrado ao lado esquerdo do switcher
		 */
		leftLabel: String,
		/**
		 * Valor que sera feito o bind
		 */
		value: Boolean,

		disabled: Boolean,

		/**
		 * Listener para caso tenha que executar algum evento depois do valor ter alterado
		 */
		clickListener: {
			type: Function,
		},
	},
	computed: {
		/**
		 * Id unico do componente
		 */
		uniqueID() {
			return uuidv4()
		},
	},
	methods: {
		change(e) {
			this.$emit('input', e.target.checked)
			if (this.clickListener) this.clickListener()
		},
	},
}
</script>

<style scoped>
.container__switcher {
	display: flex;
	align-items: center;
	user-select: none;
}

.container__switcher label {
	font-size: 0.75rem;
	margin-left: 0.5rem;
	color: rgb(var(--color-primary));
	z-index: 1;
}

.container__swicher__checkbox {
	display: flex;
	position: relative;
}

input[type='checkbox'] {
	height: 20px;
	width: 45px;
	background-color: rgb(var(--color-neutral));
	appearance: none;
	outline: none;
	border-radius: 100px;
	transition: all 0.1s linear;
}

input[type='checkbox'].dual__option {
	background-color: var(--color-green);
}
input[type='checkbox']:disabled {
	background-color: rgb(var(--color-neutral), 0.4);
}

input:checked[type='checkbox'] {
	background-color: rgb(var(--color-default));
}

input:checked[type='checkbox']:disabled {
	background-color: rgb(var(--color-default), 0.4);
}

input[type='checkbox']:before {
	position: absolute;
	content: '';
	right: 25px;
	height: 20px;
	width: 20px;
	border-radius: 50%;
	background-color: white;
	border: 1px solid rgb(207, 207, 207);
	transition: right 0.1s linear;
}

input:checked[type='checkbox']:before {
	right: 0;
}

label.active {
	font-weight: 700;
}
</style>
